function NotFound() {
    return (
        <div>
            <h1>404 Not Found</h1>
            <p>The page you're looking for does not exist.</p>
        </div>
    );
}

export default NotFound;
